import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import {
	findTagByName,
	getTagLabel,
	getTagIcon,
	getPageFeatureLevel
} from './tag-service';

const FEATURE_BADGE_THRESHOLD = 50;
const NEW_BADGE_THRESHOLD = 30; //days

const PRODUCT_TAG_PREFIX = 'cxproduct:';

function getBadges({ date, tags }) {
	let badges = [];

	let thirty_days_ago = moment()
		.subtract(NEW_BADGE_THRESHOLD, 'days')
		.unix();

	if (findTagByName(tags, 'fee')) {
		badges.push('paid');
	}

	if (getPageFeatureLevel({ tags }) >= FEATURE_BADGE_THRESHOLD) {
		badges.push('featured');
	}

	if (moment(date).unix() > thirty_days_ago) {
		badges.push('new');
	}

	return badges;
}

export const ContentExchangeCard = ({ id, url, title, date, tags }) => {
	let badges = getBadges({ date, tags });
	let productTags = tags.filter(t => t.indexOf(PRODUCT_TAG_PREFIX) === 0);
	let directoryTheme ='/wp-content/themes/dc';

	return (
		<a key={id} href={url} className="card content-exchange-page-card">
			<div className="card-header">
				{badges.map(b => (
					<span className="badge">
						<img
							className="badge-image"
							src={`${directoryTheme}/resources/images/content-exchange-icons/${b}.svg`}
							alt={b}
						/>
					</span>
				))}
			</div>
			<div className="content-type">
				{getTagLabel(tags, 'packagetype')}
			</div>
			<div className="title">{title}</div>
			<div className="call-to-action">Learn More</div>
			<ul className="product-line">
				{productTags.map(tag => (
					<li
						className="product-line-item"
						data-tooltip={tag.replace(PRODUCT_TAG_PREFIX, '')}
					>
						<img
							className="product-line-icon"
							src={getTagIcon(tag)}
							alt={tag.replace(PRODUCT_TAG_PREFIX, '')}
						/>
					</li>
				))}
			</ul>
		</a>
	);
};

ContentExchangeCard.propTypes = {
	id: PropTypes.string,
	tags: PropTypes.array,
	url: PropTypes.string,
	title: PropTypes.string,
	date: PropTypes.string
};
